import { AppIdentity } from '@/typings/domain'
import { V2User } from '@/typings/v2Api'
import { appendQueryParams } from '../utils/url'
import v2Fetch from './v2Fetch'

export function login(identity: string, password: string) {
  return v2Fetch<V2User[]>('/sign_in', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ auth_key: identity, password, app_identity: AppIdentity.Nextapp }),
  })
}

export type ThirdPartyLoginProvider = 'wechat'

export type LoginViaThirdPartyArgs = {
  code: string
  provider: ThirdPartyLoginProvider
  platform: 'wechat_cyborg'
}

export function loginViaThirdParty({ code, provider, platform }: LoginViaThirdPartyArgs) {
  return v2Fetch<V2User[]>(
    appendQueryParams('/third_party_user', {
      code,
      app_identity: AppIdentity.Nextapp,
      provider,
      platform,
    })
  )
}

export type RegisterOrBindViaThirdPartyArgs = {
  code: string
  provider: ThirdPartyLoginProvider
  mobileNo: string
}

export function registerOrBindViaThirdParty({ code, provider, mobileNo }: RegisterOrBindViaThirdPartyArgs) {
  return v2Fetch<V2User[]>('/third_party_user', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ code, provider, app_identity: AppIdentity.Nextapp, mobile_no: mobileNo }),
  })
}

type GeetestData = {
  pass_token: string
  lot_number: string
  gen_time: string
  captcha_output: string
  type: string
}

export function sendSMSCode(mobile: string, geetestData?: GeetestData | null) {
  const body: {
    mobile_no: string
    geetest4_data?: GeetestData
  } = {
    mobile_no: mobile,
  }

  // Only include geetest data if provided
  if (geetestData) {
    body.geetest4_data = geetestData
  }

  return v2Fetch<void>('/password_free_login/sms_codes', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      // Nginx rate-limits this endpoint against brute force; X-App-Key identifies the app so nginx can allow the request through.
      'X-App-Key': process.env.EXPO_PUBLIC_X_APP_KEY ?? ''
    },
    body: JSON.stringify(body),
  })
}

export function smsCodeVerify(mobile: string, code: string) {
  return v2Fetch<void>('/sms_code_verify', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ mobile_number: mobile, verification_code: code }),
  })
}

export function passwordFreeLogin(mobile: string, code: string) {
  return v2Fetch<V2User[]>('/password_free_login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ mobile_no: mobile, verification_code: code }),
  })
}
